import * as yup from 'yup';

const schema = yup.object().shape({
  SituacaoFiscalizacao: yup.number("Só é possível inserir números nesse campo"),
  Observacao: yup.string("Campo deve conter somente caracteres").required("Este campo é obrigatório"),
  DataInicioInstalacao: yup.date().typeError("Valor inválido. Este campo é obrigatório").required("Valor inválido. Este campo é obrigatório"),
  DataTerminoInstalacao: yup.date().typeError("Valor inválido. Este campo é obrigatório").required("Valor inválido. Este campo é obrigatório"),
  SolicitacaoCompartilhamento: yup.object().shape({
    value: yup.string().required(),
    label: yup.string()
  })
});

const defaultValues = {
  SituacaoFiscalizacao: 0,
  solicitacaoCompartilhamento: {
    value: "",
    label: ""
  },
  DataInicioInstalacao: new Date(),
  DataTerminoInstalacao: new Date()
}

export { schema, defaultValues }